import React from 'react';
import {Col} from 'antd';
import DocumentMeta from 'react-document-meta';
import {bacheloresMeta} from '../constants/meta';
import {CusImage, Section, PageHeader} from '../common'
import Image1 from '../img/bc1.jpg';
import Image2 from '../img/bc2.jpg';
import Image3 from '../img/bc3.jpg';

const Bachelores = () => {
  return (
    <DocumentMeta {...bacheloresMeta}>
      <PageHeader title="Бакалаври" />
      <Section>
        <Col md={16}>
          <h2>Бакалавърски тези/дипломни работи</h2>
          <p>Предлагаме индивидуално <strong>разработване на бакалавърски тези</strong> и <storng>изготвяне на дипломни работи</storng> за всички икономически специалности при гарантирана уникалност на разработката, професионализъм и конфиденциалност. Помощ при формулиране на темата, изготвяне на примерно съдържание, корекции, презентация/резюме за защитата и <strong>отговор на рецензията</strong>.</p>

          <h2>Курсови работи</h2>
          <p>Индивидуално <strong>разработване на различни по вид курсови работи</strong>, <strong>реферати</strong>, <strong>есета</strong>, доклади и др. за всички икономически специалности при зададено от Вас условие.</p>
        </Col>
        <Col style={{margin: "auto"}} xs={20} md={8}>
          <CusImage src={Image1} alt="Разработване на курсова работа" />
        </Col>
      </Section>
      <Section background>
        <Col style={{margin: "auto"}} xs={20} md={8}>
          <CusImage src={Image2} frameStyle="top" alt="Вземане на изпит" />
        </Col>
        <Col md={16}>
          <h2>Казуси</h2>
          <p>Дългогодишният ни опит гарантира <strong>разработката на качествени казуси</strong> за всички икономически специалности за редовно и <strong>дистанционно обучение</strong>, отговарящи на изпратеното от Вас условие.</p>

          <h2>Тестове</h2>
          <p>Предлагаме помощ при <strong>решаване на тестове</strong> за изпити за всички икономически специалности.</p>
        </Col>
      </Section>
      <Section>
        <Col style={{margin: "auto"}} xs={20} md={16}>
          <h2>Дистанционно обучение</h2>
          <p>Може да разчитате на <strong>пълното ни съдействие в процеса на Вашето дистанционно обучение</strong> за всички икономически специалности, което включва <strong>разработване на исканите курсови задачи</strong> и помощ при <strong>полагане на тестове</strong>.</p>

          <h2>Excel</h2>
          <p>Извършване на разнообразни <strong>изчисления в Excel</strong>.</p>

          <h2>Power Point</h2>
          <p>Изготвяне на индивидуални <strong>презентации</strong>.</p>
        </Col>
        <Col style={{margin: "auto"}} xs={20} md={8}>
          <CusImage src={Image3} frameStyle="full" alt="Завършване на висше" />
        </Col>
      </Section>
    </DocumentMeta>
  );
};

export default Bachelores;